import React, { useEffect, useState } from 'react';
import { Accordion, Col, Row, Tab, Tabs } from 'react-bootstrap';
import './medicines.css'
import Antidotos from './Antidotos';
import Toxicos from './Toxicos';
import Toxindromes from './Toxindromes';


export default function Medicines() {
    const [toxicos, setToxicos] = useState([])
    const [antidotos, setAntidotos] = useState([])
    const [toxindromes, setToxindromes] = useState([])
    const [selected, setSelected] = useState('')
    const [search, setSearch] = useState('')
    //const url = 'https://toxifinder.herokuapp.com/' //Dirección del Backend
    //const url = 'http://192.168.1.187:5000/' // Local IP:PORT
    const url = 'https://toxfinderserver.azurewebsites.net/'//'http://127.0.0.1:5000/' // Local IP:PORT
    useEffect(() => {
        fetch(url + 'toxicos')
            .then(data => data.json())
            .then(data => {
                setToxicos(data)
            })

        fetch(url + 'antidotos')
            .then(data => data.json())
            .then(data => {
                setAntidotos(data)
            })

        fetch(url + 'toxindromes')
            .then(data => data.json())
            .then(data => {
                setToxindromes(data)
            })
    }, [])

    return <div className='mt-0 mb-5'>
        <Row>
            <Col className="searchContainer">
                <div>
                    <p className="searchTitle">Buscar en la base de datos</p>
                    <input onChange={(e) => setSearch(e.target.value)} type="text" placeholder="Buscador..." />
                </div>
            </Col>
        </Row>
        {
            !(selected || search) && 
            <Row>
                <Col className="d-flex justify-content-center mt-4">
                    <div className="category">
                        {
                            toxicos.length > 0 &&
                            <div onClick={() => setSelected('toxicos')}>
                                Tóxicos
                            </div>
                        }
                        {
                            antidotos.length > 0 &&
                            <div onClick={() => setSelected('antidotos')}>
                                Antídotos
                            </div>
                        }
                        {
                            toxindromes.length > 0 &&
                            <div onClick={() => setSelected('toxindromes')}>
                                Toxíndromes
                            </div>
                        }
                    </div>
                </Col>
            </Row>
        }

        {
            (!!selected || !!search) &&
            <Row>
                <Col md={6} className='m-auto mt-5 tabContainer'>
                    <Tabs
                        id="controlled-tab-example"
                        defaultActiveKey='toxicos'
                        onSelect={(k) => setSelected(k)}
                        className="mb-3"
                    >
                        {
                            toxicos.length > 0 &&
                            <Tab eventKey="toxicos" title="Tóxicos">
                                <Accordion alwaysOpen>
                                    {
                                        toxicos.filter(item => {
                                            return item.name.toLowerCase()
                                                .indexOf(search.toLowerCase()) > -1
                                        })
                                            .map((item, index) => {
                                                return <Toxicos item={item} key={index} index={index} />
                                            })
                                    }
                                </Accordion>

                            </Tab>
                        }
                        {
                            antidotos.length > 0 &&
                            <Tab eventKey="antidotos" title="Antídotos">
                                <Accordion alwaysOpen>
                                    {
                                        antidotos.filter(item => {
                                            return item.name.toLowerCase()
                                                .indexOf(search.toLowerCase()) > -1
                                        })
                                            .map((item, index) => {
                                                return <Antidotos item={item} index={index} key={index} />
                                            })
                                    }
                                </Accordion>
                            </Tab>
                        }
                        {
                            toxindromes.length > 0 &&
                            <Tab eventKey="toxindromes" title="Toxíndromes">
                                <Accordion alwaysOpen>
                                    {
                                        toxindromes.filter(item => {
                                            return item.name.toLowerCase()
                                                .indexOf(search.toLowerCase()) > -1
                                        })
                                            .map((item, index) => {
                                                return <Toxindromes item={item} index={index} key={index} />
                                            })
                                    }
                                </Accordion>
                            </Tab>
                        }
                    </Tabs>
                </Col>
            </Row>
        }

    </div>;
}
